<template>
  <div class="animated fadeIn" :key="submissionId">
    <b-row class="mb-3">
      <b-col md="2" class="pt-2">Fertilizer recommendations</b-col>
      <b-col>
        <template v-for="(projection, index) in projections">
          <project-soil-crop-form
            :key="index"
            :projection="projection"
            :options="cropNames"
            :projectionListLength="projections.length"
            :index="index"
            @cropUpdate="cropUpdate"
            @updateYield="updateYield"
            @updateProjectionList="updateProjectionList"
          />
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import crops from "@/shared/_crops";
import ProjectSoilCropForm from "./ProjectSoilCropForm";

export default {
  name: "ProjectSoilNextCropFormGroups",
  components: {
    ProjectSoilCropForm,
  },
  props: {
    submissionId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    submission_soil() {
      return this.currentSubmission.submission_soil;
    },
    projections() {
      return this.submission_soil.projections;
    },
    cropNames() {
      return crops.map((i) => i.crop);
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleProjectionUpdate() {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: {
          ...this.submission_soil,
          projections: this.projections,
        },
        name: "submission_soil",
      });
    },
    updateProjectionList(index) {
      if (index || index === 0) {
        this.projections.splice(index, 1);
      } else {
        this.projections.push({
          crop: null,
          yield: null,
          unit: null,
        });
      }
      this.handleProjectionUpdate();
    },
    updateYieldAndUnit(crop, i) {
      let tmp = crops.find((j) => j.crop === crop);
      i.yield = tmp
        ? this.submission_soil.irrigated
          ? tmp.irrigated || null
          : tmp.dryland || null
        : null;
      i.unit = tmp ? tmp.units || null : null;
    },
    updateYield(value, projectionIndex) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: {
          ...this.submission_soil,
          projections: this.projections.map((projection, index) => {
            if (index === projectionIndex)
              return {
                ...projection,
                yield: value,
              };
            return projection;
          }),
        },
        name: "submission_soil",
      });
    },
    cropUpdate(e, projection) {
      this.updateYieldAndUnit(e, projection);
      this.handleProjectionUpdate();
    },
  },
  watch: {
    'submission_soil.irrigated': {
      handler() {
        this.projections.forEach(projection => {
          this.updateYieldAndUnit(projection.crop, projection)
        })
      },
      deep: true,
    },
  },
};
</script>
